var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.169,
    height: 25.751,
    viewBox: "0 0 23.169 25.751",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "settings",
    transform: "translate(-1.203)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_500",
    "data-name": "Path 500",
    d: "M12.292,8a4.292,4.292,0,1,0,4.292,4.292A4.292,4.292,0,0,0,12.292,8Zm0,6.438a2.146,2.146,0,1,1,2.146-2.146A2.146,2.146,0,0,1,12.292,14.438Z",
    transform: "translate(0.496 0.584)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_501",
    "data-name": "Path 501",
    d: "M22.759,14.914l-.476-.275a9.764,9.764,0,0,0,0-3.53l.476-.275a3.221,3.221,0,1,0-3.219-5.579l-.477.276a9.632,9.632,0,0,0-3.057-1.762v-.55a3.219,3.219,0,1,0-6.438,0v.55A9.632,9.632,0,0,0,6.513,5.535l-.48-.278a3.221,3.221,0,1,0-3.219,5.579l.476.275a9.764,9.764,0,0,0,0,3.53l-.476.275A3.221,3.221,0,1,0,6.033,20.5l.477-.276a9.632,9.632,0,0,0,3.058,1.762v.55a3.219,3.219,0,1,0,6.438,0v-.55a9.632,9.632,0,0,0,3.056-1.766l.48.277a3.221,3.221,0,1,0,3.219-5.579Zm-2.734-4.051a7.562,7.562,0,0,1,0,4.024,1.073,1.073,0,0,0,.5,1.216l1.163.672a1.073,1.073,0,1,1-1.073,1.859l-1.165-.674a1.073,1.073,0,0,0-1.3.177,7.493,7.493,0,0,1-3.48,2.012,1.073,1.073,0,0,0-.806,1.04v1.344a1.073,1.073,0,0,1-2.146,0V21.188a1.073,1.073,0,0,0-.806-1.04,7.493,7.493,0,0,1-3.478-2.016,1.073,1.073,0,0,0-1.3-.177l-1.163.673A1.073,1.073,0,1,1,3.89,16.77L5.053,16.1a1.073,1.073,0,0,0,.5-1.216,7.562,7.562,0,0,1,0-4.024,1.073,1.073,0,0,0-.5-1.211L3.889,8.976A1.073,1.073,0,0,1,4.962,7.117l1.165.674a1.073,1.073,0,0,0,1.3-.173,7.493,7.493,0,0,1,3.48-2.012,1.073,1.073,0,0,0,.806-1.044V3.219a1.073,1.073,0,1,1,2.146,0V4.562a1.073,1.073,0,0,0,.806,1.04,7.493,7.493,0,0,1,3.48,2.016,1.073,1.073,0,0,0,1.3.177l1.163-.673a1.073,1.073,0,1,1,1.073,1.858l-1.163.672a1.073,1.073,0,0,0-.5,1.211Z",
    transform: "translate(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.3ebb268b424c46c8e4ec843e708eb8bf.svg";
export { ForwardRef as ReactComponent };